/**
 * @generated SignedSource<<5ff2487ee7d9ba7655e0ec52a4359060>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
import { FragmentRefs } from "relay-runtime";
export type agendaAppointmentDrawerPatient_appointment$data = {
  readonly patient: {
    readonly contactChannel: ContactChannel;
    readonly isContactChannelVerified: boolean;
  };
  readonly " $fragmentType": "agendaAppointmentDrawerPatient_appointment";
};
export type agendaAppointmentDrawerPatient_appointment$key = {
  readonly " $data"?: agendaAppointmentDrawerPatient_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"agendaAppointmentDrawerPatient_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "agendaAppointmentDrawerPatient_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contactChannel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isContactChannelVerified",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "d652bf7f8d274ab21784f99487fd4c3e";

export default node;
